import React from 'react';

const ErrorMessage = () => {
    return (
        <div>
            <h1 className="display-4 bg-danger p-2">
                Data Information Error!!
            </h1>
        </div>
    );
};

export default ErrorMessage;